<div [id]="blogContainerId" class="dinings-page-container">
  <app-small-header textColor="#fff" [homePage]="true"></app-small-header>
  <div class="hero-section">
    <video class="hero-video" autoplay muted loop playsinline>
      <source
        src="https://txl-videos.s3.ap-south-1.amazonaws.com/udaan-videos/Grains.webm"
        type="video/webm"
      />
    </video>
    <div class="overlay"></div>
    <div class="logo-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="380px"
        height="231.083"
        viewBox="0 0 518.622 231.083"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectangle_10"
              data-name="Rectangle 10"
              width="518.622"
              height="231.083"
              fill="none"
            />
          </clipPath>
        </defs>
        <g id="Group_3" data-name="Group 3" transform="translate(-606 -401)">
          <g id="Group_2" data-name="Group 2" transform="translate(606 401)">
            <g id="Group_1" data-name="Group 1" clip-path="url(#clip-path)">
              <path
                id="Path_1"
                data-name="Path 1"
                d="M414.328,228.651c2.917,25.215-36.026,21.273-28.386-1.705,3.069-9.23,16.041-13.094,23.113-6.186-3.536,5.427-5.274,2.041-9.261,2.136-3.267.077-7.837,2.969-8.6,6.288-2.81,12.185,14.252,16.222,17.121,4.733H402.3l0-5.265Z"
                transform="translate(-95.638 -53.97)"
                fill="#037870"
              />
              <path
                id="Path_2"
                data-name="Path 2"
                d="M320.827,233.409c1.411,1.069,6.912-14.459,7.626-14.906,1.051-.659,5.062.2,6.645-.116-4.363,8.08-7.413,18.212-11.87,26.077-.43.758-.891,1.989-2.025,1.722-1.5-.353-12.061-24.341-13.158-27.8,1.556.144,3.4-.286,4.886-.008,2.8.522,6.4,12.066,7.9,15.033"
                transform="translate(-76.532 -54.222)"
                fill="#037870"
              />
              <rect
                id="Rectangle_1"
                data-name="Rectangle 1"
                width="18.789"
                height="6.012"
                transform="translate(265.33 185.954)"
                fill="#037870"
              />
              <rect
                id="Rectangle_2"
                data-name="Rectangle 2"
                width="18.789"
                height="5.261"
                transform="translate(265.33 164.158)"
                fill="#037870"
              />
              <path
                id="Path_3"
                data-name="Path 3"
                d="M676.078,233.433V218.4h6.012V246.21a3.175,3.175,0,0,1-2.667-.715c-4.855-3.14-10.03-11.758-15.371-15.067V246.21c-1.215.067-6.012.323-6.012-1.127V218.4a4.607,4.607,0,0,1,3.42.714c4.294,2.515,9.736,11.518,14.617,14.317"
                transform="translate(-163.487 -54.244)"
                fill="#037870"
              />
              <path
                id="Path_4"
                data-name="Path 4"
                d="M591.054,218.425v10.522h10.522V218.425h6.012v26.68c0,1.451-4.8,1.194-6.012,1.127V234.208H591.054v12.025h-6.012V218.425Z"
                transform="translate(-145.35 -54.267)"
                fill="#037870"
              />
              <path
                id="Path_5"
                data-name="Path 5"
                d="M452.041,218.307l6.016,0,0,7.519c5.285-4.216,6.993-9.279,15.02-7.512,1.4,1.243-9.1,8.857-8.911,10.765.744,2.147,10.612,16.176,9.663,17.035-1.681-.319-5.371.564-6.608-.155-.943-.549-5.1-10.078-6.559-11.851-.974-1.181-2.612.7-2.612,1.112v10.9h-6.012Z"
                transform="translate(-112.307 -54.148)"
                fill="#037870"
              />
              <path
                id="Path_6"
                data-name="Path 6"
                d="M567.024,219.682c-1.865,6.214-5.1,3.5-9.406,3.688-10.881.467-10.709,17.429.767,17.362,3.56-.02,7.715-4.379,8.325,3.006-13.88,9.1-31.61-7.242-20.367-21.075,5.221-6.424,13.714-6.411,20.681-2.981"
                transform="translate(-134.851 -54.01)"
                fill="#037870"
              />
              <path
                id="Path_7"
                data-name="Path 7"
                d="M527.586,218.425l0,5.265-8.271,0v22.547h-6.012V223.685l-8.271,0,0-5.265Z"
                transform="translate(-125.474 -54.266)"
                fill="#037870"
              />
              <rect
                id="Rectangle_3"
                data-name="Rectangle 3"
                width="6.012"
                height="27.808"
                transform="translate(367.541 164.158)"
                fill="#037870"
              />
              <path
                id="Path_8"
                data-name="Path 8"
                d="M642.564,247.425v6.012H624.151c-1.575,0-1.575-6.012,0-6.012Z"
                transform="translate(-154.774 -61.471)"
                fill="#037870"
              />
              <rect
                id="Rectangle_4"
                data-name="Rectangle 4"
                width="19.54"
                height="5.261"
                transform="translate(468.25 164.158)"
                fill="#037870"
              />
              <rect
                id="Rectangle_5"
                data-name="Rectangle 5"
                width="16.534"
                height="5.261"
                transform="translate(468.25 174.68)"
                fill="#037870"
              />
              <rect
                id="Rectangle_6"
                data-name="Rectangle 6"
                width="15.783"
                height="5.261"
                transform="translate(265.33 174.68)"
                fill="#037870"
              />
              <path
                id="Path_9"
                data-name="Path 9"
                d="M230.69,217.372c6.012.846,10.581,6.907,7.454,12.721-.71,1.32-3.794,3.284-3.865,4.179-.095,1.193,6.13,10.707,5.051,11.655-1.464-.284-4.888.509-5.89-.119-.513-.321-5.056-10.189-5.211-10.943a32.612,32.612,0,0,1-.169-6.218c.28-.261,3.787.719,4.921-1.5,2.121-4.152-5.381-4.122-7.927-3.762v22.547h-6.012V217.372c3.66.361,8.111-.5,11.649,0"
                transform="translate(-54.42 -53.965)"
                fill="#037870"
              />
              <path
                id="Path_10"
                data-name="Path 10"
                d="M185.3,218.425v17.662c0,6.261,11.273,6.261,11.273,0V218.425h5.261v20.668a28.071,28.071,0,0,1-2.242,3.771c-3.716,4.13-11.343,4.731-15.748,1.443-1.018-.76-3.805-4.347-3.805-5.214V218.425Z"
                transform="translate(-44.73 -54.267)"
                fill="#037870"
              />
              <rect
                id="Rectangle_7"
                data-name="Rectangle 7"
                width="19.54"
                height="6.012"
                transform="translate(190.926 185.954)"
                fill="#037870"
              />
              <rect
                id="Rectangle_8"
                data-name="Rectangle 8"
                width="19.54"
                height="5.261"
                transform="translate(190.926 164.158)"
                fill="#037870"
              />
              <rect
                id="Rectangle_9"
                data-name="Rectangle 9"
                width="16.534"
                height="5.261"
                transform="translate(190.926 174.68)"
                fill="#037870"
              />
              <path
                id="Path_11"
                data-name="Path 11"
                d="M165.495,223.138c-.569-1.685-3.5-4.713-5.054-4.713h-12.4v27.808h6.012V234.959c7.745.923,14.252-3.5,11.442-11.821m-11.445,5.812v-5.268c.34-.338,5.52.221,5.912.853,2.341,3.772-3.081,5.344-5.913,4.415"
                transform="translate(-36.78 -54.267)"
                fill="#037870"
              />
              <path
                id="Path_12"
                data-name="Path 12"
                d="M64.289,19.425,88.7,42.347c-2.682,6.071-13.018-7.688-15.014-5.633-1.956,8.395,3.671,12.147,6.369,18.8,8.378,20.653,1.163,47.988-22.865,53.012-9.432,1.972-18.531-2.2-22.759,8.813-1.914,4.988,4.925,7.386,8.683,9.688,27.154,16.634,60.41,23.29,57.653,62.655-3.123,44.571-59.814,62.535-88.69,28.507C2.027,206.345-6.415,179.17,6.76,167.071c9.083-8.34,21.2,3.954,13.582,13.582-7.176,9.065-21.927-1.377-14.328,20.3,7.4,21.1,30.65,35.171,52.809,30.955,22.311-4.245,44.014-29.156,25.391-49.782-18.905-13.935-42.558-23.614-61.571-36.883-5.816-4.058-6.911-4.735-3.384-11.521C25.47,121.779,37.692,109.415,44.7,97.54c7.381-2.978-2.99,8.033-1.828,9.062,8.82.344,17.187-2.443,18.064-12.366a298.5,298.5,0,0,0,0-39.89c-.744-8.661-4.21-13.7-13.188-14.62-11.939-1.22-20.328,1.7-21.437,14.62-.886,10.32-.951,35.984,2.073,45.329,1.107,3.419,3.375,5.156,3.963,8.43-14.567-2.213-25.28-12.229-27.6-26.883C-.912,45.433,26.942,28.655,59.4,37.846c2.865.811,7.865,3.745,9.574,4.009,3.182.492,2.659-3.048,2.276-5.34-.635-3.805-4.082-7.237-7.091-9.44-3.128-2.291-9.538-4.134-11.512-5.775a1.03,1.03,0,0,1,.373-1.874Z"
                transform="translate(0 -4.826)"
                fill="#EFA005"
              />
              <path
                id="Path_13"
                data-name="Path 13"
                d="M442.245,148.068c1.8-.386,3.542-2.978,3.4-4.872l-.029-69.141c-2.993-7.86-9.1,1.485-10.98,1.81-.807.138-2.518-1.57-2.519-1.826-.005-1.408,18.048-16.941,19.862-19.958,1.605-.924,11.309-1.21,12.49-.383,1.75,1.227-1,8.882,4.081,8.608,2.145-.116,6.4-3.489,8.895-4.555,18.182-7.786,52.09-6.378,54.607,18.551,2.125,21.048-1.607,45.428.053,66.835-.194,1.606,2.9,4.929,4.089,4.929h13.152a10.08,10.08,0,0,1,0,3.006H496.733a10.08,10.08,0,0,1,0-3.006h12.4c1.426,0,4.594-3.776,4.15-5.62-2-23.226,2.651-50.89-.1-73.586-2.83-23.349-43.955-10.441-47.684,7.013l-.369,68.1c-.529,1.481,2.507,4.1,3.419,4.1H481.7a10.08,10.08,0,0,1,0,3.006H430.22c-1.294,0-1.3-3.006,0-3.006,3.164,0,9.4.565,12.025,0"
                transform="translate(-106.645 -13.22)"
                fill="#EFA005"
              />
              <path
                id="Path_14"
                data-name="Path 14"
                d="M385.54,51.425v79.289a11.527,11.527,0,0,0,1.864,2.645c3.151,2.722,10.365.913,10.916,1.492a11.9,11.9,0,0,1,0,3H353.975a11.9,11.9,0,0,1,0-3c1.361-1.429,11.891,3.777,12.816-6.356,1.623-17.78-1.151-38.187-.2-56.242-2.846-7.322-6.79-.888-9.361-.646-1.032.1-2.615-1.378-2.44-2.414.164-.969,12.042-10.735,13.86-12.488,8.047-7.756,23.1-22.439,22.922-34.178-.156-10.036-9.778-19.8-19.939-20.011-5.785-.117-14.392,4.092-15.352,10.25-2.264,14.52,15.578,6.714,15.028,18.733s-21.615,9.921-23.349-5.25c-4.754-41.585,64.217-30.436,42.479,10.157-1.651,3.082-9.777,12.372-10.036,13.284-1.289,4.539,2.638,2.694,5.138,1.733"
                transform="translate(-86.39 0)"
                fill="#EFA005"
              />
              <path
                id="Path_15"
                data-name="Path 15"
                d="M659.43,83.94l-2.252.006c-.616-6.151-.812-13.7-3.628-19.3-6.755-13.436-43.318-13.488-40.649,7.582,2.589,20.43,47.234,14.918,53.824,40.119,5.67,21.683-13.926,42-35.485,41.543-15.037-.317-35.751-13.873-30.22-31.029,3.521-10.924,15.592-6.614,14.818,1.221-.633,6.426-14.589,5.914-5.641,16.986,9.476,11.727,33.366,12.45,43.2,1.106,8.907-10.272,3.2-20.207-7.341-25.694-18.366-9.558-46.572-9-44.484-36.659,1.644-21.785,21.237-31.381,41.167-26.16,2.749.719,9.808,4.754,11.083,4.734,3.326-.05,1.69-7.3,5.6-6.015Z"
                transform="translate(-149.093 -12.975)"
                fill="#EFA005"
              />
              <path
                id="Path_16"
                data-name="Path 16"
                d="M166.107,56.109v10.9c0,.413,1.139,1.124,1.842,1.136,2.793.05,11.926-11.826,20.327-12.788,9.746-1.116,19.482,2.271,17.616,13.865-.92,5.714-9.327,7.929-13.86,4.932-5.852-3.869-1.8-10.366-4.056-13.225-2.534-3.2-7.95,1.547-10.2,3.473-4.908,4.2-8.122,8.717-8.692,15.358-1.769,20.6,1.333,43.737.077,64.61,1,6.315,9.7,3.378,10.474,4.188a11.863,11.863,0,0,1,0,3H139.051a11.863,11.863,0,0,1,0-3c.389-.41,10.525.824,10.525-2.634V75.274c0-1.147-2.886-2.022-4.128-1.952-3.274.184-5.779,4.341-6.868,4.529-.807.139-2.518-1.57-2.519-1.826-.005-1.435,18.353-17.307,20.293-20.278a18.46,18.46,0,0,1,9.756.362"
                transform="translate(-33.803 -13.703)"
                fill="#EFA005"
              />
              <path
                id="Path_17"
                data-name="Path 17"
                d="M311.4,144.1c-.228-.28-5.735,2.3-6.653-.484C302.26,116.541,315.957,56.6,273.417,55.4,258.909,55,235.765,68.1,240.974,84.891c3.468,11.179,18.583,8.014,17.864-2.032-.228-3.182-3.066-5.738-3.63-8.443-2.918-14,16.872-19.519,26.836-12.562,8.735,6.1,12.842,24.695,1.835,30.3-12.427,6.329-38.234,6.918-46.513,16.618-11.378,13.328-7.809,36.943,9.748,42.875,5.792,1.956,18.058,2.645,23.336-.773,2.707-1.753,12.064-15.219,14.643-12.788.707.668.244,8.738,1.581,10.828,2.9,4.53,13.654,2.071,17.929.79,1.91-.573,9.08-2.8,6.793-5.6M285.849,121.93c-.751,7.113-5.788,14.384-10.542,19.52-17.032,18.4-28.3-6-24.557-22.3,2.357-10.258,8.208-14.948,17.656-18.419,2.967-1.09,12.41-4.306,15.006-4.6.911-.1,2.437.194,2.437,1,0,7.652.774,17.474,0,24.8"
                transform="translate(-57.345 -13.763)"
                fill="#EFA005"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
    <div class="text-box">
      <div class="text-box-inner">
        <p class="main-heading">Exceptional gastronomy in beautiful spaces</p>
        <p class="sub-heading">
          Find us in Darjeeling, Gangtok, Pelling, Lachung & Siliguri and
          discover the rich tapestry of pure vegetarian cuisine as you embark on
          a delectable journey through our diverse menu in our restaurant. From
          the aromatic spices of India to the vibrant herbs of Southeast Asia,
          our carefully curated selection showcases the cultural tapestry of
          flavors. Indulge & savor the delicate dishes, we invite you to expand
          your palate and appreciate the artistry of cooking.
        </p>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="dinings-top-margin pb-5">
      <app-section-title
        [title]="'Our Restaurants'"
        [subtitle]="'A Culinary Experience Awaits'"
      ></app-section-title>
      <div class="mt-4 mb-5 px-4 w-100 sticky-top hotel-tabs-sticky">
        <app-tab
          [tabs]="tabs"
          [hScroll]="true"
          [vScroll]="false"
          [selectedIndex]="selectedIndex"
          (tabSelected)="onTabChange($event)"
        >
        </app-tab>
      </div>

      <app-dinings-card-carousel
        [properties]="filteredDinings"
      ></app-dinings-card-carousel>
    </div>
  </div>
</div>
